import { render, staticRenderFns } from "./CourseListAddNew.vue?vue&type=template&id=3e311ce2&"
import script from "./CourseListAddNew.vue?vue&type=script&lang=js&"
export * from "./CourseListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CourseListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports